import { render, staticRenderFns } from "./DestinationCategory.vue?vue&type=template&id=66af0f81&"
import script from "./DestinationCategory.vue?vue&type=script&lang=js&"
export * from "./DestinationCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports